import FeatureGates from '@atlaskit/feature-gate-js-client';
import { LOOM_PRODUCT_ID, SWITCHER_LOOM_RECOMMENDATION_EXPERIMENT_KEY } from './constants';
const LOOM_SWITCHER_RECOMMENDATION_DISMISSED = 'loomSwitcherRecommendationDismissed';
const localStorageProvider = window.localStorage;
const TRUE_AS_STRING = 'true';
export function loomSwitcherExperimentWasDismissed() {
  return localStorageProvider.getItem(LOOM_SWITCHER_RECOMMENDATION_DISMISSED) === TRUE_AS_STRING;
}
export function dismissLoomSwitcherExperiment() {
  localStorageProvider.setItem(LOOM_SWITCHER_RECOMMENDATION_DISMISSED, TRUE_AS_STRING);
}
export function captureNotInterestedDismissal(productId) {
  if (productId !== LOOM_PRODUCT_ID) {
    return;
  }
  dismissLoomSwitcherExperiment();
}
export function getExperimentCohort() {
  return FeatureGates.getExperimentValue(SWITCHER_LOOM_RECOMMENDATION_EXPERIMENT_KEY, 'cohort', 'not-enrolled');
}
export function createFireExposureEvent(cohort, fireViewedUIEvent) {
  return function fireExposureEvent(apps) {
    if (cohort !== 'control' && cohort !== 'variation') {
      return;
    }
    fireViewedUIEvent({
      eventType: 'track',
      // Using @ts-ignore here to avoid the strict typing in `surface-analytics`.
      // `surface-analytics` doesn't have a track event function, so using a UI event function to send exposure event.
      // @ts-ignore
      actionSubject: 'feature',
      // @ts-ignore
      action: 'exposed',
      tags: ['growth']
    }, {
      source: 'atlassianSwitcherDiscoverProductsSection',
      recommendedProductIds: apps.map(app => app.productId)
    }, {
      flagKey: SWITCHER_LOOM_RECOMMENDATION_EXPERIMENT_KEY,
      cohort
    });
  };
}